var dynamicRequire = require('../../dynamicRequire');
var React = dynamicRequire('react');
var DimensionChooser = require('./DimensionChooser.jsx');
var Mssg = dynamicRequire('Mssg.jsx');

class DimensionsChooser extends React.Component {
    render() {
        return <div>
            {this.getChooser('width')}
            {this.getChooser('height')}
            {this.getChooser('depth')}
        </div>
    }
    getChooser(dimension) {
        var props = {
            start: this.props.case.dimensions.interior[dimension],
            range: {
                min: this.props.dimensions[dimension].min,
                max: this.props.dimensions[dimension].max,
            },
        }
        return <DimensionChooser dimension={dimension} {...props} label={'nc_casefactory.'+dimension} isCmMode={this.props.isCmMode}/>
    }
}

DimensionsChooser.contextTypes = {
};


module.exports = DimensionsChooser;


// WEBPACK FOOTER //
// ./js/caseconfigurator-ui/lib/components/Dimensions/DimensionsChooser.jsx